import React from 'react';
import { c } from '../ui-components/src/utils/tailwind-merge';

type CheckedBoxProps = {
  className?: string;
};

export const CheckedBox: React.FC<CheckedBoxProps> = ({ className = '' }) => (
  <svg
    className={c(className)}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 12 9"
  >
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeWidth="2"
      d="M1.5 5L4.6 7.99999L11 1"
    ></path>
  </svg>
);
